/**
 * SyncEvesUseCase
 *
 * Use case for synchronizing EVSEs (Electric Vehicle Supply Equipment) data.
 * Triggers data sync for a specified operator.
 */

import type { OcpiAdminRepository } from '../data/ocpi-admin-repository';

export class SyncEvesUseCase {
  constructor(private readonly repository: OcpiAdminRepository) {}

  /**
   * Execute sync EVSEs operation
   *
   * @param operatorId - Nayax operator ID
   * @param publishToOcpi - Whether to publish to OCPI after sync (default: true)
   */
  async execute(operatorId: number, publishToOcpi: boolean = true): Promise<void> {
    await this.repository.syncEvses(operatorId, publishToOcpi);
  }
}
